/**
 * Logo Component
 *
 * Displays the DARAK logo with link to home.
 */

import React from 'react';
import { Link } from 'react-router-dom';

interface LogoProps {
  variant?: 'light' | 'dark';
  className?: string;
}

export const Logo: React.FC<LogoProps> = ({
  className = '',
}) => {
  return (
    <Link
      to="/"
      className={`flex items-center ${className}`}
    >
      <img
        src="/logos/logo-wide.png"
        alt="DARAK"
        className="h-8 md:h-10 w-auto object-contain"
      />
    </Link>
  );
};

export default Logo;
